var _rect, _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _mask5, _path5, _path6, _mask6, _path7, _path8, _mask7, _path9, _path0, _mask8, _path1, _path10, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.82121,
    y: 1.20402,
    width: 18.3537,
    height: 25.0417,
    stroke: "#8A8A8A",
    strokeWidth: 0.92367
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.11328 3.10156H16.096V6.24888H3.11328V3.10156Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11328 3.49498H16.096V2.70815H3.11328V3.49498ZM16.096 5.85547H3.11328V6.6423H16.096V5.85547Z",
    fill: "#8A8A8A",
    mask: "url(#path-2-inside-1_4806_12099)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 13.7266H17.02V16.4976H2.94141V13.7266Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 14.12H17.02V13.3331H2.94141V14.12ZM17.02 16.1042H2.94141V16.891H17.02V16.1042Z",
    fill: "#8A8A8A",
    mask: "url(#path-4-inside-2_4806_12099)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 8.64844H17.02V11.4194H2.94141V8.64844Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 9.04185H17.02V8.25502H2.94141V9.04185ZM17.02 11.026H2.94141V11.8129H17.02V11.026Z",
    fill: "#8A8A8A",
    mask: "url(#path-6-inside-3_4806_12099)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 18.3438H17.02V21.5766H2.94141V18.3438Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 18.7372H17.02V17.9503H2.94141V18.7372ZM17.02 21.1832H2.94141V21.97H17.02V21.1832Z",
    fill: "#8A8A8A",
    mask: "url(#path-8-inside-4_4806_12099)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 5.85156H17.2751V8.99888H2.71875V5.85156Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 5.85156H17.2751V8.99888H2.71875V5.85156Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 6.24498H17.2751V5.45815H2.71875V6.24498ZM17.2751 8.60547H2.71875V9.3923H17.2751V8.60547Z",
    fill: "#8A8A8A",
    mask: "url(#path-10-inside-5_4806_12099)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 16.0391H17.02V18.8101H2.94141V16.0391Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 16.0391H17.02V18.8101H2.94141V16.0391Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 16.4325H17.02V15.6456H2.94141V16.4325ZM17.02 18.4167H2.94141V19.2035H17.02V18.4167Z",
    fill: "#8A8A8A",
    mask: "url(#path-12-inside-6_4806_12099)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-7_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 10.9531H17.02V14.186H2.94141V10.9531Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 10.9531H17.02V14.186H2.94141V10.9531Z",
    fill: "#F8F8F8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 11.3465H17.02V10.5597H2.94141V11.3465ZM17.02 13.7926H2.94141V14.5794H17.02V13.7926Z",
    fill: "#8A8A8A",
    mask: "url(#path-14-inside-7_4806_12099)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-8_4806_12099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 21.2031H17.2751V24.3504H2.71875V21.2031Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 21.2031H17.2751V24.3504H2.71875V21.2031Z",
    fill: "#F8F8F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 21.5965H17.2751V20.8097H2.71875V21.5965ZM17.2751 23.957H2.71875V24.7439H17.2751V23.957Z",
    fill: "#8A8A8A",
    mask: "url(#path-16-inside-8_4806_12099)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.08092,
    y: 3.49498,
    width: 13.8037,
    height: 20.4576,
    stroke: "#8A8A8A",
    strokeWidth: 0.78683
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVents);
export default __webpack_public_path__ + "static/media/vents.2dc57b06990e79192cc3487f44098045.svg";
export { ForwardRef as ReactComponent };